<p-toast></p-toast>

<div class="container">
  <div class="main-content" *ngFor="let item of data; let i = index">
    <div class="card">
      <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
        ">
        <!-- Left Button -->
        <button class="patent-btn" (click)="navigateToWebsite('wipo', i)">
          Click Me - For Updated Patent at Patent Scope (WIPO)
        </button>

        <!-- Right Export Buttons -->
      </div>

      <p class="note">
        USER CAN REFINE THE PATENT DATA WITH ADDITION OF “SEARCH TERM” IN SCRIPT
        (EXAMPLE): ALL: (PHARMACEUTICAL) AND AP: (PFIZER) AND ALL: (POLYMORPH)
        AND ALL: (PARTICLE) AND ALL: (PROCESS)
      </p>
      <!-- Product Information Section -->
      <section class="product-info" id="productinfo">
        <h4 style="
            font-weight: 800;
            margin-left: 10px;
            font-size: 20px;
            color: #388e3c;
            margin-bottom: 20px;
            text-align: left;
            background: linear-gradient(to right, #388e3c, #006400);
            -webkit-background-clip: text;
            color: transparent;
            text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1),
              -2px -2px 5px rgba(0, 0, 0, 0.1);
            letter-spacing: 1px;
            transition: color 0.3s ease, text-shadow 0.3s ease;
          ">
          {{ item.activeIngredient || "-" }}
          <button class="copy-btn" (click)="copyToClipboard(item.activeIngredient)" pTooltip="Copy to clipboard"
            tooltipPosition="top">
            <i class="pi pi-copy"></i>
          </button>
        </h4>
        <div class="product-detail" id="contentToExport1" style="margin-top: 20px">
          <div class="grid grid-cols-3 gap-4">
            <div class="note" *ngIf="
                displayMap['genericConstrainingDate'] &&
                item.genericConstrainingDate
              ">
              <h6 style="
                  text-align: center;
                  display: flex;
                  justify-content: center;
                ">
                GENERIC CONSTRAINING DATE (GCD)
              </h6>
              <p style="
                  text-align: center;
                  display: flex;
                  justify-content: center;
                ">
                {{
                item.genericConstrainingDate
                ? (item.genericConstrainingDate | date : "yyyy-MM-dd")
                : "-"
                }}
                <button class="copy-btn" *ngIf="item.genericConstrainingDate" (click)="
                    copyToClipboardFormattedDate(item.genericConstrainingDate)
                  " pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </p>
            </div>
            <div class="product-info" *ngIf="displayMap['developmentalCode'] && item.developmentalCode">
              <h6>
                DEVELOPMENTAL CODE
                <button class="copy-btn" (click)="copyToClipboard(item.developmentalCode)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.developmentalCode || "-" }}
              </p>
            </div>
            <div class="product-info" *ngIf="
                displayMap['nameOfGenericChemClass'] &&
                item.nameOfGenericChemClass
              ">
              <h6>
                Name of Generic Chemistry
                <button class="copy-btn" (click)="copyToClipboard(item.nameOfGenericChemClass)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.nameOfGenericChemClass || "-" }}
              </p>
            </div>
            <div class="product-info" *ngIf="displayMap['yearOfDiscovery'] && item.yearOfDiscovery">
              <h6>
                Year of Discovery
                <button class="copy-btn" (click)="copyToClipboard(item.yearOfDiscovery)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.yearOfDiscovery || "-" }}
              </p>
            </div>
            <div class="product-info" *ngIf="displayMap['launchingYear'] && item.launchingYear">
              <h6>
                Launching Year
                <button class="copy-btn" (click)="copyToClipboard(item.launchingYear)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.launchingYear || "-" }}
              </p>
            </div>
          </div>
        </div>
        <br />
        <!-- Chemical Structure Image -->
        <div class="chemical-structure" *ngIf="displayMap['chemicalStructure'] && item.chemicalStructure">
          <h2>Chemical Structure</h2>

          <!-- Container for the two images -->
          <div class="image-container">
            <img class="inventor-logo" [src]="
                'https://www.chemrobotics.com/agropat/images/chemical_structure/' +
                item.chemicalStructure
              " alt="Inventor Logo" />
          </div>

          <!-- Button to trigger modal -->
          <button class="view-btn" *ngIf="isColumnVisible(item, 'chemicalStructure')" (click)="ImageFullView(item)">
            View
          </button>
        </div>

        <!-- Bootstrap Modal for Full Image View -->
        <div class="modal fade" id="imageModal" tabindex="-1" aria-labelledby="imageModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="imageModalLabel">
                  Chemical Structure
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <!-- Image displayed inside modal -->
                <img *ngIf="fullImageUrl" [src]="fullImageUrl" alt="Chemical Structure" class="img-fluid" />
              </div>
            </div>
          </div>
        </div>

        <!-- Innovators' Logos -->
        <div class="logos" id="contentToExport3">
          <!-- <h3 class="logos-title">Innovators' Logos</h3> -->
          <!-- Title remains above images -->
          <!-- inventorLogo -->

          <div class="logos-images">
            <img style="width: 100px" *ngIf="displayMap['inventorLogo'] && item.inventorLogo" [src]="
                'https://www.chemrobotics.com/agropat/images/innovators_logo/' +
                item.inventorLogo
              " alt="Inventor Logo" class="inventor-logo" (error)="onImageError($event)" />
            <!-- <ng-template #placeholder>
              <span style="width: 300px; display: inline-block"
                >INVENTOR LOGO</span
              >
            </ng-template> -->
          </div>
          <div class="result-header">
            <h6 style="margin-top: 8px" *ngIf="isColumnVisible(item, 'innovatorOriginator')">
              {{ item.innovatorOriginator || "-" }}
            </h6>
          </div>
        </div>

        <!-- Additional Product Details -->
        <div class="product-additional-details">
          <div class="grid grid-cols-2 gap-4" id="contentToExport4">
            <div class="product-info" *ngIf="displayMap['gbrn'] && item.gbrn">
              <h6>
                GREEN BOOK REGISTRATION NUMBER (GBRN)
                <button class="copy-btn" (click)="copyToClipboard(item.gbrn)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.gbrn || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="
                displayMap['companyRegistrationNumber'] &&
                item.companyRegistrationNumber
              ">
              <h6>
                COMPANY REGISTRATION NUMBER
                <button class="copy-btn" (click)="copyToClipboard(item.companyRegistrationNumber)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>{{ item.companyRegistrationNumber || "-" }}</p>
            </div>

            <div class="product-info" *ngIf="
                displayMap['chemicalDirectoryReferenceNumberCdrn'] &&
                item.chemicalDirectoryReferenceNumberCdrn
              ">
              <h6>
                Chemical Directory Reference Number (CDRN)
                <button class="copy-btn" (click)="
                    copyToClipboard(item.chemicalDirectoryReferenceNumberCdrn)
                  " pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.chemicalDirectoryReferenceNumberCdrn || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['launchStatus'] && item.launchStatus">
              <h6>
                LAUNCHING STATUS
                <button class="copy-btn" (click)="copyToClipboard(item.launchStatus)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.launchStatus || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['developmentStage'] && item.developmentStage">
              <h6>
                DEVELOPMENT STAGE
                <button class="copy-btn" (click)="copyToClipboard(item.developmentStage)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.developmentStage || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['indication'] && item.indication">
              <h6>
                indication
                <button class="copy-btn" (click)="copyToClipboard(item.indication)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.indication || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['productType'] && item.productType">
              <h6>
                PRODUCT TYPE
                <button class="copy-btn" (click)="copyToClipboard(item.productType)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.productType || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['notes'] && item.notes">
              <h6>
                INNOVATOR(S)
                <button class="copy-btn" (click)="copyToClipboard(item.notes)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.notes || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['iupac'] && item.iupac">
              <h6>
                iupac
                <button class="copy-btn" (click)="copyToClipboard(item.iupac)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.iupac || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['casRn'] && item.casRn">
              <h6>
                CAS RN
                <button class="copy-btn" (click)="copyToClipboard(item.casRn)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.casRn || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['chemicalClass'] && item.chemicalClass">
              <h6>
                CHEMICAL CLASS
                <button class="copy-btn" (click)="copyToClipboard(item.chemicalClass)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.chemicalClass || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['isoStatus'] && item.isoStatus">
              <h6>
                ISO STATUS
                <button class="copy-btn" (click)="copyToClipboard(item.isoStatus)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.isoStatus || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['yearWiseIso'] && item.yearWiseIso">
              <h6>
                YEAR WISE ISO
                <button class="copy-btn" (click)="copyToClipboard(item.yearWiseIso)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.yearWiseIso || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="
                displayMap['resistanceActionCommitteeRacFracHracIrac'] &&
                item.resistanceActionCommitteeRacFracHracIrac
              ">
              <h6>
                Resistance Action Committee (RAC)
                <button class="copy-btn" (click)="
                    copyToClipboard(
                      item.resistanceActionCommitteeRacFracHracIrac
                    )
                  " pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.resistanceActionCommitteeRacFracHracIrac || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="
                displayMap['mechanismOfActionMoa'] && item.mechanismOfActionMoa
              ">
              <h6>
                Mechanism of Action (MOA)
                <button class="copy-btn" (click)="copyToClipboard(item.mechanismOfActionMoa)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.mechanismOfActionMoa || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['pubchemId'] && item.pubchemId">
              <h6>
                PUBCHEM CID:
                <button class="copy-btn" (click)="copyToClipboard(item.pubchemId)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <a style="
                  margin: 5px;
                  padding: 10px;
                  background: #006400;
                  color: rgb(255 237 141);
                  text-decoration: none;
                  border-radius: 5px;
                  cursor: pointer;
                  display: inline-block;
                " target="_blank" [href]="
                  'https://pubchem.ncbi.nlm.nih.gov/compound/' + item.pubchemId
                ">
                {{ item.pubchemId || "-" }}
              </a>
            </div>

            <div class="product-info" *ngIf="
                displayMap['SUMMARY_SALES_DATA_SALES_YEAR_'] &&
                item.summarySalesDataSalesYearM
              ">
              <h6>
                Sales / Year ($m.)
                <button class="copy-btn" (click)="copyToClipboard(item.summarySalesDataSalesYearM)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.summarySalesDataSalesYearM || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="
                displayMap['keyManufacturerBrand'] && item.keyManufacturerBrand
              ">
              <h6>
                Key Manufacturer / Brand
                <button class="copy-btn" (click)="copyToClipboard(item.keyManufacturerBrand)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.keyManufacturerBrand || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['manufacturers'] && item.manufacturers">
              <h6>
                Manufacturers
                <button class="copy-btn" (click)="copyToClipboard(item.manufacturers)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.manufacturers || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['applicationRate'] && item.applicationRate">
              <h6>
                Application Rate (Rate g/ha)
                <button class="copy-btn" (click)="copyToClipboard(item.applicationRate)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.applicationRate || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['mainCrops'] && item.mainCrops">
              <h6>
                Main Crops
                <button class="copy-btn" (click)="copyToClipboard(item.mainCrops)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.mainCrops || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="
                displayMap['combiningPartnerMixtures'] &&
                item.combiningPartnerMixtures
              ">
              <h6>
                Combining Partner / Mixture
                <button class="copy-btn" (click)="copyToClipboard(item.combiningPartnerMixtures)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.combiningPartnerMixtures || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['applicationTiming'] && item.applicationTiming">
              <h6>
                Application Timing
                <button class="copy-btn" (click)="copyToClipboard(item.applicationTiming)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.applicationTiming || "-" }}
              </p>
            </div>
            <div class="product-info" *ngIf="
                displayMap['applicationConcentration'] &&
                item.applicationConcentration
              ">
              <h6>
                APPLICATION CONCENTRATION
                <button class="copy-btn" (click)="copyToClipboard(item.applicationConcentration)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.applicationConcentration || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['applicationRate'] && item.applicationRate">
              <h6>
                APPLICATION RATE
                <button class="copy-btn" (click)="copyToClipboard(item.applicationRate)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.applicationRate || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="displayMap['mainPests'] && item.mainPests">
              <h6>
                Main Pests
                <button class="copy-btn" (click)="copyToClipboard(item.mainPests)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.mainPests || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="
                displayMap['formulationGlobally'] && item.formulationGlobally
              ">
              <h6>
                FORMULATION GLOBALLY
                <button class="copy-btn" (click)="copyToClipboard(item.formulationGlobally)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.formulationGlobally || "-" }}
              </p>
            </div>

            <div class="product-info" *ngIf="
                displayMap['genericConstrainingDate'] &&
                item.genericConstrainingDate
              ">
              <h6>
                GENERIC CONSTRAINING DATE (GCD)
                <button class="copy-btn" (click)="copyToClipboard(item.genericConstrainingDate)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{
                item.genericConstrainingDate
                ? (item.genericConstrainingDate | date : "yyyy-MM-dd")
                : "-"
                }}
              </p>
            </div>

            <div class="product-info" *ngIf="
                displayMap['genericPropDevCadateWdrw'] &&
                item.genericPropDevCadateWdrw
              ">
              <h6>
                GENERIC / PROPRIETARY / DEVELOPING CANDIDATE / WITHDRAWN
                <button class="copy-btn" (click)="copyToClipboard(item.genericPropDevCadateWdrw)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.genericPropDevCadateWdrw || "-" }}
              </p>
            </div>
          </div>

          <div class="section-wrapper" id="dataAvailablity" *ngIf="dataAvailablity.length > 0" let i="index1">
            <hr class="section-divider" />
            <h2 class="section-title">Data Availability</h2>

            <a *ngFor="let data of dataAvailablity" class="" [href]="
                'https://www.chemrobotics.com/agropat/pdf/gsda/docs/' +
                data.documents
              " target="_blank">
              <button class="btn btn-success m-1" style="
                  background: linear-gradient(
                    145.5deg,
                    #388e3c,
                    #235e5e 99.58%
                  );
                  color: rgb(255 237 141);
                  gap: 10px;
                ">
                {{ data.nameOfDocuments }}
              </button>
            </a>
          </div>

          <!-- First Section Wrapper -->
          <div class="section-wrapper" id="description" *ngIf="item.description">
            <hr class="section-divider" />
            <h2 class="section-title" *ngIf="displayMap['description'] && item.description">
              description:
            </h2>
            <p>
              {{ item.description }}
            </p>
          </div>

          <div class="section-wrapper" id="gbrn" *ngIf="
              item.apiAgrochemical ||
              item.gbrn ||
              item.activeIngredient ||
              item.productClassification ||
              item.synonymsCommonName ||
              item.pesticideType ||
              item.tradeNameProprietaryName ||
              item.releatedCompoundsAis ||
              item.casName ||
              item.resistanceActionCommitteeRacFracHracIrac ||
              item.herbicideResistanceClassificationWssa ||
              item.mechanismOfActionMoa ||
              item.uses ||
              item.chemicalClass ||
              item.substanceOrigin ||
              item.yearOfDiscovery ||
              item.launchStatus ||
              item.iupac ||
              item.casRn ||
              item.isoStatus ||
              item.inchi ||
              item.inchiKey ||
              item.canonicalSmiles ||
              item.smilesCode ||
              item.MOLECULAR_FORMULA ||
              item.ecNo ||
              item.usEpaChemicalCode ||
              item.pubchemId ||
              item.unNumber ||
              item.STRAIN_NO ||
              item.anatoTherapChemAtcClsCode
            ">
            <hr class="section-divider" />
            <h2 class="section-title">PRODUCT IDENTIFICATION</h2>
            <p>
              This field discloses basic identifiers of the compound such as CAS
              RN, USEPA RN, Pubchem ID, etc.
            </p>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div *ngIf="displayMap['apiAgrochemical'] && item.apiAgrochemical" class="product-info">
                  <h6>
                    API/AGROCHEMICAL
                    <button class="copy-btn" (click)="copyToClipboard(item.apiAgrochemical)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.apiAgrochemical }}
                  </p>
                </div>

                <div *ngIf="displayMap['gbrn'] && item.gbrn" class="product-info">
                  <h6>
                    GREEN BOOK REGISTRATION NUMBER (GB RN)
                    <button class="copy-btn" (click)="copyToClipboard(item.gbrn)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.gbrn }}
                  </p>
                </div>

                <div *ngIf="
                    displayMap['activeIngredient'] && item.activeIngredient
                  " class="product-info">
                  <h6>
                    ACTIVE INGREDIENT
                    <button class="copy-btn" (click)="copyToClipboard(item.activeIngredient)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.activeIngredient }}
                  </p>
                </div>

                <div *ngIf="
                    displayMap['productClassification'] &&
                    item.productClassification
                  " class="product-info">
                  <h6>
                    PRODUCT CLASSIFICATION
                    <button class="copy-btn" (click)="copyToClipboard(item.productClassification)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.productClassification }}
                  </p>
                </div>

                <div *ngIf="
                    displayMap['synonymsCommonName'] && item.synonymsCommonName
                  " class="product-info">
                  <h6>
                    SYNONYMS / COMMON NAME
                    <button class="copy-btn" (click)="copyToClipboard(item.synonymsCommonName)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.synonymsCommonName }}
                  </p>
                </div>

                <div *ngIf="displayMap['pesticideType'] && item.pesticideType" class="product-info">
                  <h6>
                    PESTICIDE TYPE
                    <button class="copy-btn" (click)="copyToClipboard(item.pesticideType)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.pesticideType }}
                  </p>
                </div>

                <div *ngIf="
                    displayMap['tradeNameProprietaryName'] &&
                    item.tradeNameProprietaryName
                  " class="product-info">
                  <h6>
                    TRADE NAMES / PROPRIETARY NAME
                    <button class="copy-btn" (click)="copyToClipboard(item.tradeNameProprietaryName)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.tradeNameProprietaryName }}
                  </p>
                </div>

                <div *ngIf="
                    displayMap['releatedCompoundsAis'] &&
                    item.releatedCompoundsAis
                  " class="product-info">
                  <h6>
                    RELATED COMPOUNDS (AI's)
                    <button class="copy-btn" (click)="copyToClipboard(item.releatedCompoundsAis)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.releatedCompoundsAis }}
                  </p>
                </div>

                <div *ngIf="displayMap['casName'] && item.casName" class="product-info">
                  <h6>
                    CAS NAME
                    <button class="copy-btn" (click)="copyToClipboard(item.casName)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.casName }}
                  </p>
                </div>

                <div *ngIf="
                    displayMap['synonymsCommonName'] &&
                    item.resistanceActionCommitteeRacFracHracIrac
                  " class="product-info">
                  <h6>
                    Resistance Action Committee (RAC)
                    <button class="copy-btn" (click)="
                        copyToClipboard(
                          item.resistanceActionCommitteeRacFracHracIrac
                        )
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.resistanceActionCommitteeRacFracHracIrac }}
                  </p>
                </div>

                <div *ngIf="
                    displayMap['herbicideResistanceClassificationWssa'] &&
                    item.herbicideResistanceClassificationWssa
                  " class="product-info">
                  <h6>
                    HERBICIDE RESISTANCE CLASSIFICATION (WSSA)
                    <button class="copy-btn" (click)="
                        copyToClipboard(
                          item.herbicideResistanceClassificationWssa
                        )
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.herbicideResistanceClassificationWssa }}
                  </p>
                </div>

                <div *ngIf="
                    displayMap['mechanismOfActionMoa'] &&
                    item.mechanismOfActionMoa
                  " class="product-info">
                  <h6>
                    Mechanism of Action (MOA)
                    <button class="copy-btn" (click)="copyToClipboard(item.mechanismOfActionMoa)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.mechanismOfActionMoa }}
                  </p>
                </div>

                <div *ngIf="displayMap['uses'] && item.uses" class="product-info">
                  <h6>
                    USE(S)
                    <button class="copy-btn" (click)="copyToClipboard(item.uses)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.uses }}
                  </p>
                </div>

                <div *ngIf="displayMap['chemicalClass'] && item.chemicalClass" class="product-info">
                  <h6>
                    CHEMICAL CLASS
                    <button class="copy-btn" (click)="copyToClipboard(item.chemicalClass)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.chemicalClass }}
                  </p>
                </div>

                <div *ngIf="displayMap['substanceOrigin'] && item.substanceOrigin" class="product-info">
                  <h6>
                    SUBSTANCE ORIGIN
                    <button class="copy-btn" (click)="copyToClipboard(item.substanceOrigin)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.substanceOrigin }}
                  </p>
                </div>
                <div *ngIf="displayMap['yearOfDiscovery'] && item.yearOfDiscovery" class="product-info">
                  <h6>
                    YEAR OF DISCOVERY
                    <button class="copy-btn" (click)="copyToClipboard(item.yearOfDiscovery)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.yearOfDiscovery }}
                  </p>
                </div>

                <div *ngIf="displayMap['launchStatus'] && item.launchStatus" class="product-info">
                  <h6>
                    LAUNCHING STATUS
                    <button class="copy-btn" (click)="copyToClipboard(item.launchStatus)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.launchStatus }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['yearWiseOffPatentMolecules'] &&
                    item.yearWiseOffPatentMolecules
                  ">
                  <h6>
                    YEAR WISE OFF PATENT MOLECULES
                    <button class="copy-btn" (click)="copyToClipboard(item.yearWiseOffPatentMolecules)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.yearWiseOffPatentMolecules || "-" }}
                  </p>
                </div>

                <div *ngIf="displayMap['iupac'] && item.iupac" class="product-info">
                  <h6>
                    iupac
                    <button class="copy-btn" (click)="copyToClipboard(item.iupac)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.iupac }}
                  </p>
                </div>

                <div *ngIf="displayMap['casRn'] && item.casRn" class="product-info">
                  <h6>
                    CAS RN
                    <button class="copy-btn" (click)="copyToClipboard(item.casRn)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.casRn }}
                  </p>
                </div>

                <div *ngIf="displayMap['isoStatus'] && item?.isoStatus" class="product-info">
                  <h6>
                    ISO STATUS
                    <button class="copy-btn" (click)="copyToClipboard(item.isoStatus)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.isoStatus }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'COMMENTRY')" class="product-info">
                  <h6>
                    ISO Publication
                    <button class="copy-btn" (click)="copyToClipboard(item?.COMMENTRY)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item?.COMMENTRY }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'inchi')" class="product-info">
                  <h6>
                    INCHI
                    <button class="copy-btn" (click)="copyToClipboard(item.inchi)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.inchi }}
                  </p>
                </div>

                <div *ngIf="isColumnVisible(item, 'inchiKey')" class="product-info">
                  <h6>
                    inchiKey
                    <button class="copy-btn" *ngIf="item.inchiKey" (click)="copyToClipboard(item.inchiKey)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.inchiKey }}
                  </p>
                </div>

                <div *ngIf="isColumnVisible(item, 'canonicalSmiles')" class="product-info">
                  <h6>
                    CANONICAL SMILES
                    <button class="copy-btn" (click)="copyToClipboard(item.canonicalSmiles)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.canonicalSmiles }}
                  </p>
                </div>

                <div *ngIf="isColumnVisible(item, 'smilesCode')" class="product-info">
                  <h6>
                    SMILES CODE
                    <button class="copy-btn" (click)="copyToClipboard(item.smilesCode)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.smilesCode }}
                  </p>
                </div>

                <div *ngIf="isColumnVisible(item, 'MOLECULAR_FORMULA')" class="product-info">
                  <h6>
                    MOLECULAR FORMULA
                    <button class="copy-btn" (click)="copyToClipboard(item.MOLECULAR_FORMULA)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.MOLECULAR_FORMULA }}
                  </p>
                </div>

                <div *ngIf="isColumnVisible(item, 'ecNo')" class="product-info">
                  <h6>
                    EC. NO.
                    <button class="copy-btn" (click)="copyToClipboard(item.ecNo)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.ecNo }}
                  </p>
                </div>

                <div *ngIf="isColumnVisible(item, 'usEpaChemicalCode')" class="product-info">
                  <h6>
                    US EPA CHEMICAL CODE
                    <button class="copy-btn" (click)="copyToClipboard(item.usEpaChemicalCode)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.usEpaChemicalCode }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'uniqueIngreIdentiUnii')" class="product-info">
                  <h6>
                    UNIQUE INGREDIENT IDENTIFIER (UNII)
                    <button class="copy-btn" (click)="copyToClipboard(item.uniqueIngreIdentiUnii)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.uniqueIngreIdentiUnii }}
                  </p>
                </div>

                <div class="product-info" *ngIf="isColumnVisible(item, 'pubchemId')">
                  <h6>
                    PUBCHEM CID:
                    <button class="copy-btn" (click)="copyToClipboard(item.pubchemId)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <a style="
                      margin: 5px;
                      padding: 10px;
                      background: #006400;
                      color: rgb(255 237 141);
                      text-decoration: none;
                      border-radius: 5px;
                      cursor: pointer;
                      display: inline-block;
                    " target="_blank" [href]="
                      'https://pubchem.ncbi.nlm.nih.gov/compound/' +
                      item.pubchemId
                    ">
                    {{ item.pubchemId || "-" }}
                  </a>
                </div>

                <div *ngIf="isColumnVisible(item, 'unNumber')" class="product-info">
                  <h6>
                    UN NUMBER
                    <button class="copy-btn" (click)="copyToClipboard(item.unNumber)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.unNumber }}
                  </p>
                </div>

                <div *ngIf="isColumnVisible(item, 'STRAIN_NO')" class="product-info">
                  <h6>
                    STRAIN NO
                    <button class="copy-btn" (click)="copyToClipboard(item.STRAIN_NO)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.STRAIN_NO }}
                  </p>
                </div>

                <div *ngIf="isColumnVisible(item, 'anatoTherapChemAtcClsCode')" class="product-info">
                  <h6>
                    ANATOMICAL THERAPEUTIC CHEMICAL (ATC) CLASSIFICATION CODE
                    <button class="copy-btn" (click)="copyToClipboard(item.anatoTherapChemAtcClsCode)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.anatoTherapChemAtcClsCode }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Divider Line -->
          <hr class="section-divider" />
          <div class="section-wrapper" id="physicochemical-computed" *ngIf="
              displayMap['summaryPhysicochemPropComp'] &&
              item.summaryPhysicochemPropComp
            ">
            <h2 class="section-title">PHYSICOCHEMICAL (COMPUTED PROPERTIES)</h2>
            <div class="product-additional-details" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4" style="margin-left: 0">
                <div *ngIf="item.summaryPhysicochemPropComp" class="product-info">
                  <h6>
                    SUMMARY PHYSICOCHEMICAL PROPERTIES (COMPUTED)
                    <button class="copy-btn" (click)="copyToClipboard(item.summaryPhysicochemPropComp)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.summaryPhysicochemPropComp }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Divider Line -->

          <!-- Second Section Wrapper -->
          <div *ngIf="
              item.summaryPhysicochemPropExperi ||
              item.isomerism ||
              item.polymorphism ||
              item.description ||
              item.meltingPointC ||
              item.boilingPointC ||
              item.degradationPointC ||
              item.flashpointC ||
              item.freezingPointC ||
              item.agueousSolubilityMgL ||
              item.solubilityInOrganicSolventsMgL ||
              item.solubilityInNHeptaneMgL ||
              item.solubilityInMethanolMgL ||
              item.solubilityInAcetoneMgL ||
              item.solubilityInEthylAcetateMgL ||
              item.SOLUBILITY_IN_OTHER_ORGANIC_SOLVENT_S_MG_L ||
              item.densityGMl ||
              item.bulkDensityGMlSpecificGravity ||
              item.vapourPressure ||
              item.logpOctanolWater ||
              item.stability ||
              item.pkaDissociationConstants ||
              item.henrysLawConstantAt25Cpam3Mol1 ||
              item.maximumUvVisAbsorptionLMolCm ||
              item.SURFACE_TENSION
            " class="section-wrapper" id="physicochemical-experimental">
            <hr class="section-divider" />
            <h2 class="section-title">
              PHYSICOCHEMICAL (EXPERIMENTAL PROPERTIES)
            </h2>
            <p></p>
            <div class="product-additional-details" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div *ngIf="
                    displayMap['summaryPhysicochemPropExperi'] &&
                    item.summaryPhysicochemPropExperi
                  " class="product-detail">
                  <h6 style="margin-top: 20px">
                    SUMMARY PHYSICOCHEMICAL PROPERTIES (EXPERIMENTAL)
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.summaryPhysicochemPropExperi)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.summaryPhysicochemPropExperi }}
                  </p>
                </div>
                <div *ngIf="displayMap['isomerism'] && item.isomerism" class="product-detail">
                  <h6 style="margin-top: 20px">
                    isomerism
                    <button class="copy-btn" (click)="copyToClipboard(item.isomerism)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.isomerism }}
                  </p>
                </div>

                <div *ngIf="displayMap['polymorphism'] && item.polymorphism" class="product-detail single-column">
                  <h6 style="margin-top: 20px">
                    POLYMORPHISM
                    <button class="copy-btn" (click)="copyToClipboard(item.polymorphism)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.polymorphism }}
                  </p>
                </div>
                <div *ngIf="displayMap['description'] && item.description" class="product-detail">
                  <h6 style="margin-top: 20px">
                    PHYSICAL description
                    <button class="copy-btn" (click)="copyToClipboard(item.description)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.description }}
                  </p>
                </div>
                <div *ngIf="displayMap['meltingPointC'] && item.meltingPointC" class="product-detail">
                  <h6 style="margin-top: 20px">
                    MELTING POINT (°C)
                    <button class="copy-btn" (click)="copyToClipboard(item.meltingPointC)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.meltingPointC }}
                  </p>
                </div>
                <div *ngIf="displayMap['boilingPointC'] && item.boilingPointC" class="product-detail">
                  <h6 style="margin-top: 20px">
                    BOILING POINT (°C)
                    <button class="copy-btn" (click)="copyToClipboard(item.boilingPointC)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.boilingPointC }}
                  </p>
                </div>
                <div *ngIf="
                    displayMap['degradationPointC'] && item.degradationPointC
                  " class="product-detail">
                  <h6 style="margin-top: 20px">
                    DEGRADATION POINT (°C)
                    <button class="copy-btn" (click)="copyToClipboard(item.degradationPointC)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.degradationPointC }}
                  </p>
                </div>
                <div *ngIf="displayMap['flashpointC'] && item.flashpointC" class="product-detail">
                  <h6 style="margin-top: 20px">
                    FLASHPOINT (°C)
                    <button class="copy-btn" (click)="copyToClipboard(item.flashpointC)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.flashpointC }}
                  </p>
                </div>
                <div *ngIf="displayMap['freezingPointC'] && item.freezingPointC" class="product-detail">
                  <h6>
                    FREEZING POINT (°C)
                    <button class="copy-btn" (click)="copyToClipboard(item.freezingPointC)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.freezingPointC }}
                  </p>
                </div>
                <div *ngIf="
                    displayMap['AGUEOUS_SOLUBILITY_MG_L'] &&
                    item.AGUEOUS_SOLUBILITY_MG_L
                  " class="product-detail">
                  <h6>
                    AQUEOUS SOLUBILITY (mg/l)
                    <button class="copy-btn" (click)="copyToClipboard(item.AGUEOUS_SOLUBILITY_MG_L)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.AGUEOUS_SOLUBILITY_MG_L }}
                  </p>
                </div>
                <div *ngIf="
                    displayMap['solubilityInOrganicSolventsMgL'] &&
                    item.solubilityInOrganicSolventsMgL
                  " class="product-detail">
                  <h6>
                    SOLUBILITY IN ORGANIC SOLVENTS (mg/l)
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.solubilityInOrganicSolventsMgL)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.solubilityInOrganicSolventsMgL }}
                  </p>
                </div>
                <div *ngIf="
                    displayMap['solubilityInNHeptaneMgL'] &&
                    item.solubilityInNHeptaneMgL
                  " class="product-detail">
                  <h6>
                    SOLUBILITY IN N-HEPTANE (mg/l)
                    <button class="copy-btn" (click)="copyToClipboard(item.solubilityInNHeptaneMgL)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.solubilityInNHeptaneMgL }}
                  </p>
                </div>
                <div *ngIf="
                    displayMap['solubilityInMethanolMgL'] &&
                    item.solubilityInMethanolMgL
                  " class="product-detail">
                  <h6>
                    SOLUBILITY IN METHANOL (mg/l)
                    <button class="copy-btn" (click)="copyToClipboard(item.solubilityInMethanolMgL)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.solubilityInMethanolMgL }}
                  </p>
                </div>
                <div *ngIf="
                    displayMap['solubilityInAcetoneMgL'] &&
                    item.solubilityInAcetoneMgL
                  " class="product-detail">
                  <h6>
                    SOLUBILITY IN ACETONE (mg/l)
                    <button class="copy-btn" (click)="copyToClipboard(item.solubilityInAcetoneMgL)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.solubilityInAcetoneMgL }}
                  </p>
                </div>
                <div *ngIf="
                    displayMap['solubilityInEthylAcetateMgL'] &&
                    item.solubilityInEthylAcetateMgL
                  " class="product-detail">
                  <h6>
                    SOLUBILITY IN ETHYL ACETATE (mg/l)
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.solubilityInEthylAcetateMgL)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.solubilityInEthylAcetateMgL }}
                  </p>
                </div>
                <div *ngIf="
                    displayMap['SOLUBILITY_IN_OTHER_ORGANIC_SOLVENT_S_MG_L'] &&
                    item.SOLUBILITY_IN_OTHER_ORGANIC_SOLVENT_S_MG_L
                  " class="product-detail">
                  <h6>
                    SOLUBILITY IN OTHER ORGANIC SOLVENT (S) (mg/l)
                    <button class="copy-btn" (click)="
                        copyToClipboard(
                          item.SOLUBILITY_IN_OTHER_ORGANIC_SOLVENT_S_MG_L
                        )
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.SOLUBILITY_IN_OTHER_ORGANIC_SOLVENT_S_MG_L }}
                  </p>
                </div>
                <div *ngIf="displayMap['densityGMl'] && item.densityGMl" class="product-detail">
                  <h6>
                    DENSITY (g/ml)
                    <button class="copy-btn" (click)="copyToClipboard(item.densityGMl)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.densityGMl }}
                  </p>
                </div>
                <div *ngIf="
                    displayMap['bulkDensityGMlSpecificGravity'] &&
                    item.bulkDensityGMlSpecificGravity
                  " class="product-detail">
                  <h6>
                    BULK DENSITY (g/ml) / SPECIFIC GRAVITY
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.bulkDensityGMlSpecificGravity)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.bulkDensityGMlSpecificGravity }}
                  </p>
                </div>
                <div *ngIf="displayMap['vapourPressure'] && item.vapourPressure" class="product-detail">
                  <h6>
                    VAPOUR PRESSURE
                    <button class="copy-btn" (click)="copyToClipboard(item.vapourPressure)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.vapourPressure }}
                  </p>
                </div>
                <div *ngIf="
                    displayMap['logpOctanolWater'] && item.logpOctanolWater
                  " class="product-detail">
                  <h6>
                    LOGP (OCTANOL-WATER)
                    <button class="copy-btn" (click)="copyToClipboard(item.logpOctanolWater)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.logpOctanolWater }}
                  </p>
                </div>
                <div *ngIf="displayMap['stability'] && item.stability" class="product-detail">
                  <h6>
                    stability
                    <button class="copy-btn" (click)="copyToClipboard(item.stability)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.stability }}
                  </p>
                </div>
                <div *ngIf="
                    displayMap['pkaDissociationConstants'] &&
                    item.pkaDissociationConstants
                  " class="product-detail">
                  <h6>
                    DISSOCIATION CONSTANTS(pKa)
                    <button class="copy-btn" (click)="copyToClipboard(item.pkaDissociationConstants)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.pkaDissociationConstants }}
                  </p>
                </div>
                <div *ngIf="
                    displayMap['henrysLawConstantAt25Cpam3Mol1'] &&
                    item.henrysLawConstantAt25Cpam3Mol1
                  " class="product-detail">
                  <h6>
                    HENRYS LAW CONSTANT AT 25(C) (Pam3 mol-1)
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.henrysLawConstantAt25Cpam3Mol1)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.henrysLawConstantAt25Cpam3Mol1 }}
                  </p>
                </div>
                <div *ngIf="
                    displayMap['maximumUvVisAbsorptionLMolCm'] &&
                    item.maximumUvVisAbsorptionLMolCm
                  " class="product-detail">
                  <h6>
                    MAXIMUM UV-VIS ABSORPTION l/mol
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.maximumUvVisAbsorptionLMolCm)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.maximumUvVisAbsorptionLMolCm }}
                  </p>
                </div>
                <div *ngIf="displayMap['SURFACE_TENSION'] && item.SURFACE_TENSION" class="product-detail">
                  <h6>
                    SURFACE TENSION (mN/m)
                    <button class="copy-btn" (click)="copyToClipboard(item.SURFACE_TENSION)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.SURFACE_TENSION }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="section-wrapper" id="invent-info">
            <hr class="section-divider" />
            <h2 class="section-title">INVENT INFO</h2>

            <!-- Global Patent(US) -->
            <div id="global-patent" *ngIf="isColumnVisible(item, 'inventInfo')"
              style="margin-top: 15px; margin-bottom: 15px;">
              <h4 style="font-size: 16px; font-weight: bold; color: #388e3c; margin-bottom: 5px;">1. Global Patent(US,
                EP, JP, AU, IN)</h4>
              <p *ngIf="displayMap['inventInfo2'] && item.inventInfo2">
                {{ item.inventInfo2 }}
              </p>
              <p *ngIf="displayMap['inventInfo'] && item.inventInfo">
                {{ item.inventInfo }}
              </p>
            </div>

            <!-- Brazil Patent -->
            <div id="brazil-patent" *ngIf="isColumnVisible(item, 'dummy7')"
              style="margin-top: 15px; margin-bottom: 15px;">
              <h4 style="font-size: 16px; font-weight: bold; color: #388e3c; margin-bottom: 5px;">2. Brazil Patent</h4>
              <p>{{ item.dummy7 }}</p>
            </div>

            <!-- Other Invent Info -->
            <p *ngIf="isColumnVisible(item, 'inventInfo3')">
              {{ item.inventInfo3 }}
            </p>
            <div class="product-additional-details" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div class="product-info" *ngIf="
                    displayMap['innovatorOriginator'] &&
                    item.innovatorOriginator
                  ">
                  <img style="width: 100px" *ngIf="item.inventorLogo" [src]="
                      'https://www.chemrobotics.com/agropat/images/innovators_logo/' +
                      item.inventorLogo
                    " alt="Inventor Logo" class="inventor-logo" (error)="onImageError($event)" />
                </div>

                <div class="product-info" *ngIf="
                    displayMap['innovatorOriginator'] &&
                    item.innovatorOriginator
                  ">
                  <h6>DEVELOPER</h6>
                  <p>{{ item.innovatorOriginator || "-" }}</p>
                </div>

                <div class="product-info" *ngIf="displayMap['nonPatent'] && item.nonPatent">
                  <h6>Non-Patents</h6>
                  <p>{{ item.nonPatent || "-" }}</p>
                </div>

                <div class="product-info" *ngIf="displayMap['phytotoxicity'] && item.phytotoxicity">
                  <h6>PRODUCT COMPLEXICITY & COMMERCIAL INDICATORS [PCCI]</h6>
                  <p>{{ item.phytotoxicity || "-" }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="section-wrapper" id="HISTORY" *ngIf="displayMap['histDevLicnComm'] && item.histDevLicnComm">
            <hr class="section-divider" />
            <h2 class="section-title">
              HISTORY / DEVELOPMENT / LICENCING / COMMERCIALISATION
            </h2>
            <div class="product-additional-details" style="margin-top: 20px">
              <div class="grid grid-cols-1 gap-4">
                <p>{{ item.histDevLicnComm || "-" }}</p>
              </div>
            </div>
          </div>

          <div class="section-wrapper" id="LITIGATION" *ngIf="
              displayMap['litigationOppIprMhReexam'] &&
              item.litigationOppIprMhReexam
            ">
            <hr class="section-divider" />
            <h2 class="section-title">
              LITIGATION / OPPOSITION / INTER PARTES REVIEW / MARKMAN HEARING /
              REEXAMINATION
            </h2>
            <div class="product-additional-details" style="margin-top: 20px">
              <div class="grid grid-cols-1 gap-4">
                <p>{{ item.litigationOppIprMhReexam || "-" }}</p>
              </div>
            </div>
          </div>

          <div class="section-wrapper" id="summaryPatentLandscape" *ngIf="
              item.summaryPatentLandscape ||
              item.googlePatentHyperlinkOfPatentInventInfo
            ">
            <hr class="section-divider" />
            <h2 class="section-title" id="JARVIS - NON-PATENT REFERENCES">
              JARVIS PATENT LANDSCAPE
            </h2>
            <div class="product-additional-details" style="margin-top: 20px">
              <div class="grid grid-cols-1 gap-4">
                <div class="product-info" *ngIf="isColumnVisible(item, 'summaryPatentLandscape')">
                  <h6>SUMMARY OF JARVIS PATENT LANDSCAPE</h6>
                  <p>{{ item.summaryPatentLandscape }}</p>
                </div>

                <div class="product-info" *ngIf="
                    displayMap['googlePatentHyperlinkOfPatentInventInfo'] &&
                    item.googlePatentHyperlinkOfPatentInventInfo
                  ">
                  <img src="../../../../assets/img/GooglePatents.png" alt="Patent Icon" class="patent-image"
                    style="width: 150px; height: 60px; margin-left: 6px" />
                  <p>
                    <ng-container *ngFor="
                        let link of item.googlePatentHyperlinkOfPatentInventInfo.split(
                          ';'
                        )
                      ">
                      <a class="gradient-button" *ngIf="link.trim()" [href]="
                          'https://patents.google.com/patent/' + link.trim()
                        " target="_blank">
                        {{ link.trim() }}
                      </a>
                    </ng-container>
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['googlePatentHyperlinkOfPatentInventInfo'] &&
                    item.googlePatentHyperlinkOfPatentInventInfo
                  ">
                  <img src="../../../../assets/img/espace-logo.png" alt="Patent Icon" class="patent-image"
                    style="width: 150px; height: 60px; margin-left: 6px" />
                  <p>
                    <ng-container *ngFor="
                        let link of item.googlePatentHyperlinkOfPatentInventInfo.split(
                          ';'
                        )
                      ">
                      <a style="
                          background: #be0f04 !important ;
                          transition: all 0.3s ease;
                        " *ngIf="link.trim()" [href]="
                          'https://worldwide.espacenet.com/patent/search/family/' +
                          link.trim() +
                          '/publication/' +
                          link.trim() +
                          'A1?q=' +
                          link.trim()
                        " target="_blank">
                        {{ link.trim() }}
                      </a>
                    </ng-container>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="section-wrapper" id="Jarvis Patent Landscape" *ngIf="
              displayMap['JARVIS_NON_PATENT_REFERENCES'] &&
              item.JARVIS_NON_PATENT_REFERENCES
            ">
            <hr class="section-divider" />
            <h2 class="section-title">JARVIS - NON-PATENT REFERENCES</h2>
            <div class="product-additional-details" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4" *ngIf="
                  displayMap['JARVIS_NON_PATENT_REFERENCES'] &&
                  item.JARVIS_NON_PATENT_REFERENCES
                ">
                <p>{{ item.JARVIS_NON_PATENT_REFERENCES || "-" }}</p>
              </div>
            </div>
          </div>

          <div *ngIf="
              item.moaImage ||
              item.keggImage ||
              item.summaryOfBiology ||
              item.indication ||
              item.uses ||
              item.MAXIMUM_RESIDUE_LEVEL_MRL ||
              item.mechanismOfActionMoa ||
              item.spectrumPestPathogen ||
              item.mainPests ||
              item.PEST_RESURGENCE ||
              item.crop ||
              item.applicationTiming ||
              item.dosages ||
              item.phytotoxicity
            " class="section-wrapper" id="biology">
            <hr class="section-divider" />
            <h2 class="section-title">Biology</h2>
            <div class="product-additional-details" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div class="product-info" *ngIf="
                    displayMap['summaryOfBiology'] && item.summaryOfBiology
                  ">
                  <h6>
                    SUMMARY of Biology
                    <button class="copy-btn" (click)="copyToClipboard(item.summaryOfBiology)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.summaryOfBiology || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="displayMap['indication'] && item.indication">
                  <h6>
                    indication
                    <button class="copy-btn" (click)="copyToClipboard(item.indication)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.indication || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="displayMap['uses'] && item.uses">
                  <h6>
                    Use(S)
                    <button class="copy-btn" (click)="copyToClipboard(item.uses)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.uses || "-" }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['mechanismOfActionMoa'] &&
                    item.mechanismOfActionMoa
                  ">
                  <h6>
                    MECHANISM OF ACTION (MOA)
                    <button class="copy-btn" (click)="copyToClipboard(item.mechanismOfActionMoa)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.mechanismOfActionMoa || "-" }}
                  </p>
                  <img *ngIf="displayMap['moaImage'] && item.moaImage" class="inventor-logo"
                    style="width: 350px; height: 250px" [src]="
                      'https://www.chemrobotics.com/agropat/images/ghs_pictograms/' +
                      item.moaImage
                    " />
                  <button class="view-btn-landscape" (click)="MoaFullView(item)">
                    View
                  </button>
                </div>

                <!-- Bootstrap Modal for MOA Full Image View -->
                <div class="modal fade" id="moaModal" tabindex="-1" aria-labelledby="moaModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="moaModalLabel">
                          Mechanism of Action (MOA)
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div class="modal-body">
                        <!-- Full-sized image for MOA -->
                        <img *ngIf="moaImageUrl" [src]="moaImageUrl" alt="moaImage" class="img-fluid" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="product-info" *ngIf="displayMap['keggImage'] && item.keggImage">
                  <h6>KEGG Image</h6>
                  <img class="inventor-logo" style="width: 350px; height: 250px" [src]="
                      'https://www.chemrobotics.com/agropat/images/ghs_pictograms/' +
                      item.keggImage
                    " />
                  <button class="view-btn-landscape" (click)="keggFullView(item)">
                    View
                  </button>
                </div>

                <!-- Bootstrap Modal -->
                <div class="modal fade" id="keggModal" tabindex="-1" aria-labelledby="keggModalLabel"
                  aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered modal-lg">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="keggModalLabel">
                          KEGG Image
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div class="modal-body text-center">
                        <img [src]="keggImageUrl" alt="KEGG Image" class="img-fluid" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="product-info" *ngIf="
                    displayMap['MAXIMUM_RESIDUE_LEVEL_MRL'] &&
                    item.MAXIMUM_RESIDUE_LEVEL_MRL
                  ">
                  <h6>
                    MAXIMUM RESIDUE LEVEL (MRL)
                    <button class="copy-btn" (click)="copyToClipboard(item.MAXIMUM_RESIDUE_LEVEL_MRL)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.MAXIMUM_RESIDUE_LEVEL_MRL || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="
                    displayMap['spectrumPestPathogen'] &&
                    item.spectrumPestPathogen
                  ">
                  <h6>
                    PEST / PATHOGEN / SPECTRUM
                    <button class="copy-btn" (click)="copyToClipboard(item.spectrumPestPathogen)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.spectrumPestPathogen || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="displayMap['mainPests'] && item.mainPests">
                  <h6>
                    Main Pests
                    <button class="copy-btn" (click)="copyToClipboard(item.mainPests)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.mainPests || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="displayMap['PEST_RESURGENCE'] && item.PEST_RESURGENCE">
                  <h6>
                    PEST RESURGENCE
                    <button class="copy-btn" (click)="copyToClipboard(item.PEST_RESURGENCE)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.PEST_RESURGENCE || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="displayMap['crop'] && item.crop">
                  <h6>
                    CROP
                    <button class="copy-btn" (click)="copyToClipboard(item.crop)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.crop || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="
                    displayMap['applicationTiming'] && item.applicationTiming
                  ">
                  <h6>
                    APPLICATION (Application Timing)
                    <button class="copy-btn" (click)="copyToClipboard(item.applicationTiming)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.applicationTiming || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="displayMap['dosages'] && item.dosages">
                  <h6>
                    dosages
                    <button class="copy-btn" (click)="copyToClipboard(item.dosages)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dosages || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="displayMap['phytotoxicity'] && item.phytotoxicity">
                  <h6>
                    phytotoxicity
                    <button class="copy-btn" (click)="copyToClipboard(item.phytotoxicity)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.phytotoxicity || "-" }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="
              displayMap['summaryApprovalStatus'] && item.summaryApprovalStatus
            " class="section-wrapper" id="approval-status">
            <hr class="section-divider" />
            <h2 class="section-title">APPROVAL STATUS</h2>
            <div class="product-additional-details" style="margin-top: 20px">
              <div class="grid grid-cols-1 gap-4">
                <div class="product-info">
                  <h6>
                    SUMMARY APPROVAL STATUS
                    <button class="copy-btn" (click)="copyToClipboard(item.summaryApprovalStatus)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.summaryApprovalStatus || "-" }}
                  </p>
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>

          <div class="section-wrapper" id="country-wise" *ngIf="
              item.countryWiseRegulatoryInformation ||
              item.euPesticidesData ||
              item.ukLerapStatus ||
              item.usdaPesticideDataProgram ||
              item.FDA_REQUIREMENTS ||
              item.examplesOfRecordedResistance ||
              item.resistanceActionCommitteeRacFracHracIrac ||
              item.herbicideResistanceClassificationWssa
            ">
            <hr class="section-divider" />
            <h2 class="section-title">COUNTRY WISE REGULATORY INFORMATION</h2>
            <div class="product-additional-details" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div class="product-info" *ngIf="
                    displayMap['countryWiseRegulatoryInformation'] &&
                    item.countryWiseRegulatoryInformation
                  ">
                  <h6>
                    SUMMARY COUNTRY WISE REGULATORY INFORMATION
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.countryWiseRegulatoryInformation)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.countryWiseRegulatoryInformation }}
                  </p>
                </div>

                <div class="product-info" *ngIf="
                    displayMap['euPesticidesData'] && item.euPesticidesData
                  ">
                  <h6>
                    EU PESTICIDES DATA
                    <button class="copy-btn" (click)="copyToClipboard(item.euPesticidesData)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.euPesticidesData }}
                  </p>
                </div>
                <div class="product-info" *ngIf="displayMap['ukLerapStatus'] && item.ukLerapStatus">
                  <h6>
                    UK LERAP STATUS
                    <button class="copy-btn" (click)="copyToClipboard(item.ukLerapStatus)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.ukLerapStatus }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['usdaPesticideDataProgram'] &&
                    item.usdaPesticideDataProgram
                  ">
                  <h6>
                    USDA PESTICIDE DATA PROGRAM
                    <button class="copy-btn" (click)="copyToClipboard(item.usdaPesticideDataProgram)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.usdaPesticideDataProgram }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['FDA_REQUIREMENTS'] && item.FDA_REQUIREMENTS
                  ">
                  <h6>
                    FDA REQUIREMENTS
                    <button class="copy-btn" (click)="copyToClipboard(item.FDA_REQUIREMENTS)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.FDA_REQUIREMENTS }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['examplesOfRecordedResistance'] &&
                    item.examplesOfRecordedResistance
                  ">
                  <h6>
                    EXAMPLES OF RECORDED RESISTANCE
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.examplesOfRecordedResistance)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.examplesOfRecordedResistance }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['resistanceActionCommitteeRacFracHracIrac'] &&
                    item.resistanceActionCommitteeRacFracHracIrac
                  ">
                  <h6>
                    Resistance Action Committee (RAC)
                    <button class="copy-btn" (click)="
                        copyToClipboard(
                          item.resistanceActionCommitteeRacFracHracIrac
                        )
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.resistanceActionCommitteeRacFracHracIrac }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['herbicideResistanceClassificationWssa'] &&
                    item.herbicideResistanceClassificationWssa
                  ">
                  <h6>
                    HERBICIDE RESISTANCE CLASSIFICATION (WSSA)
                    <button class="copy-btn" (click)="
                        copyToClipboard(
                          item.herbicideResistanceClassificationWssa
                        )
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.herbicideResistanceClassificationWssa }}
                  </p>
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>

          <div class="section-wrapper" id="product-EXCLUSIVITY" *ngIf="
              item.europeSupProtCertifiSpc ||
              item.otherCountriesSupProtCertifiSpc ||
              item.exclusivityNewChemicalEntity ||
              item.orphanDrugExclusivityOde ||
              item.pediatricDrugExclusivityPde ||
              item.nceMinusOrQidpMinus ||
              item.europeExclusivity ||
              item.canadaExclusivity ||
              item.otherCountriesExclusivities ||
              item.orangeBookPatents
            ">
            <hr class="section-divider" />
            <h2 class="section-title">PRODUCT EXCLUSIVITY</h2>
            <div class="product-additional-details" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div class="product-info" *ngIf="
                    displayMap['europeSupProtCertifiSpc'] &&
                    item.europeSupProtCertifiSpc
                  ">
                  <h6>
                    EUROPE SUPPLEMENTARY PROTECTION CERTIFICATE (SPC)
                    <button class="copy-btn" (click)="copyToClipboard(item.europeSupProtCertifiSpc)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.europeSupProtCertifiSpc }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['otherCountriesSupProtCertifiSpc'] &&
                    item.otherCountriesSupProtCertifiSpc
                  ">
                  <h6>
                    OTHER COUNTRIES SUPPLEMENTARY PROTECTION CERTIFICATE (SPC)
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.otherCountriesSupProtCertifiSpc)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.otherCountriesSupProtCertifiSpc }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['exclusivityNewChemicalEntity'] &&
                    item.exclusivityNewChemicalEntity
                  ">
                  <h6>
                    EXCLUSIVITY: NEW CHEMICAL ENTITY (NCE) / NEW BIOLOGICAL
                    ENTITY (NBE) / 505(B)(2) NEW DRUG APPLICATION (NDA)
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.exclusivityNewChemicalEntity)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.exclusivityNewChemicalEntity }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['orphanDrugExclusivityOde'] &&
                    item.orphanDrugExclusivityOde
                  ">
                  <h6>
                    ORPHAN DRUG EXCLUSIVITY (ODE)
                    <button class="copy-btn" (click)="copyToClipboard(item.orphanDrugExclusivityOde)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.orphanDrugExclusivityOde }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['pediatricDrugExclusivityPde'] &&
                    item.pediatricDrugExclusivityPde
                  ">
                  <h6>
                    PEDIATRIC DRUG EXCLUSIVITY (PDE)
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.pediatricDrugExclusivityPde)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.pediatricDrugExclusivityPde }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['nceMinusOrQidpMinus'] &&
                    item.nceMinusOrQidpMinus
                  ">
                  <h6>
                    NCE MINUS 1 (N-1 DATE) / OR QIDP MINUS-1 (QIDP-1 DATE)
                    <button class="copy-btn" (click)="copyToClipboard(item.nceMinusOrQidpMinus)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.nceMinusOrQidpMinus }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['europeExclusivity'] && item.europeExclusivity
                  ">
                  <h6>
                    EUROPE EXCLUSIVITY
                    <button class="copy-btn" (click)="copyToClipboard(item.europeExclusivity)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.europeExclusivity }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['canadaExclusivity'] && item.canadaExclusivity
                  ">
                  <h6>
                    CANADA EXCLUSIVITY
                    <button class="copy-btn" (click)="copyToClipboard(item.canadaExclusivity)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.canadaExclusivity }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['otherCountriesExclusivities'] &&
                    item.otherCountriesExclusivities
                  ">
                  <h6>
                    OTHER COUNTRIES EXCLUSIVITIES
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.otherCountriesExclusivities)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.otherCountriesExclusivities }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['orangeBookPatents'] && item.orangeBookPatents
                  ">
                  <h6>
                    ORANGE BOOK PATENTS
                    <button class="copy-btn" (click)="copyToClipboard(item.orangeBookPatents)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.orangeBookPatents }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="section-wrapper" id="impurities" *ngIf="
              item.summaryImpuritiesAsPerEpReviewReport ||
              item.impuritiesAsPerEpReviewReport
            ">
            <hr class="section-divider" />
            <h2 class="section-title">IMPURITIES</h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div class="product-info" *ngIf="
                    displayMap['summaryImpuritiesAsPerEpReviewReport'] &&
                    item.summaryImpuritiesAsPerEpReviewReport
                  ">
                  <h6>
                    SUMMARY IMPURITIES
                    <button class="copy-btn" (click)="
                        copyToClipboard(
                          item.summaryImpuritiesAsPerEpReviewReport
                        )
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.summaryImpuritiesAsPerEpReviewReport }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['impuritiesAsPerEpReviewReport'] &&
                    item.impuritiesAsPerEpReviewReport
                  ">
                  <h6>
                    IMPURITIES
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.impuritiesAsPerEpReviewReport)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.impuritiesAsPerEpReviewReport || "-" }}
                  </p>
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>

          <div class="section-wrapper" id="formulation-types"
            *ngIf="item.summaryFormulationTypes || item.formulationGlobally">
            <hr class="section-divider" />
            <h2 class="section-title">FORMULATION TYPES</h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div class="product-info" *ngIf="
                    displayMap['summaryFormulationTypes'] &&
                    item.summaryFormulationTypes
                  ">
                  <h6>
                    SUMMARY FORMULATION TYPES
                    <button class="copy-btn" (click)="copyToClipboard(item.summaryFormulationTypes)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.summaryFormulationTypes || "-" }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['formulationGlobally'] &&
                    item.formulationGlobally
                  ">
                  <h6>
                    FORMULATION GLOBALLY
                    <button class="copy-btn" (click)="copyToClipboard(item.formulationGlobally)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.formulationGlobally || "-" }}
                  </p>
                </div>
              </div>
            </div>
            <button class="view-more"></button>
          </div>

          <div class="section-wrapper" id="formulations-preparations" *ngIf="
              item.summaryFormulationsPreparations ||
              item.keyManufacturerBrand ||
              item.manufacturers
            ">
            <hr class="section-divider" />
            <h2 class="section-title">FORMULATIONS / PREPARATIONS</h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div class="product-info" *ngIf="
                    displayMap['summaryFormulationsPreparations'] &&
                    item.summaryFormulationsPreparations
                  ">
                  <h6>
                    SUMMARY FORMULATIONS / PREPARATIONS
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.summaryFormulationsPreparations)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.summaryFormulationsPreparations || "-" }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['keyManufacturerBrand'] &&
                    item.keyManufacturerBrand
                  ">
                  <h6>
                    Key Manufacturer / Brand
                    <button class="copy-btn" (click)="copyToClipboard(item.keyManufacturerBrand)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.keyManufacturerBrand }}
                  </p>
                </div>
              </div>
              <div class="grid grid-cols-1 gap-4" style="padding-top: 15px">
                <div class="product-info" *ngIf="displayMap['manufacturers'] && item.manufacturers">
                  <h6>
                    manufacturers
                    <button class="copy-btn" (click)="copyToClipboard(item.manufacturers)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.manufacturers }}
                  </p>
                </div>
              </div>
            </div>
            <button class="view-more"></button>
          </div>

          <div class="section-wrapper" id="analytical-data" *ngIf="item.analyticalData">
            <hr class="section-divider" />
            <h2 class="section-title">ANALYTICAL DATA</h2>
            <div class="product-info" *ngIf="displayMap['analyticalData'] && item.analyticalData">
              <h6>
                ANALYTICAL DATA
                <button class="copy-btn" (click)="copyToClipboard(item.analyticalData)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.analyticalData || "-" }}
              </p>
            </div>

            <button class="view-more"></button>
          </div>

          <div class="section-wrapper" id="toxicity-data" *ngIf="
              item.toxicityEpaClass || item.toxicologicalEnvironmentalReviews
            ">
            <hr class="section-divider" />
            <h2 class="section-title">TOXICITY DATA</h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div class="product-info" *ngIf="
                    displayMap['toxicityEpaClass'] && item.toxicityEpaClass
                  ">
                  <h6>
                    TOXICITY (EPA CLASS)
                    <button class="copy-btn" (click)="copyToClipboard(item.toxicityEpaClass)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.toxicityEpaClass || "-" }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['toxicologicalEnvironmentalReviews'] &&
                    item.toxicologicalEnvironmentalReviews
                  ">
                  <h6>
                    TOXICOLOGICAL & ENVIRONMENTAL REVIEWS
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.toxicologicalEnvironmentalReviews)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.toxicologicalEnvironmentalReviews || "-" }}
                  </p>
                </div>
              </div>
            </div>
            <button class="view-more"></button>
          </div>

          <div class="section-wrapper" id="mammalian-toxicology" *ngIf="
              item.summaryOfMammalianToxicology ||
              item.mammalianNonHumanAnimalsTox ||
              item.chronic ||
              item.dermal ||
              item.birdsAcuteLd50MgKg ||
              item.fishAcute96HourLc50MgL
            ">
            <hr class="section-divider" />
            <h2 class="section-title">MAMMALIAN TOXICOLOGY</h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div class="product-info" *ngIf="
                    displayMap['summaryOfMammalianToxicology'] &&
                    item.summaryOfMammalianToxicology
                  ">
                  <h6>
                    SUMMARY of MAMMALIAN TOXICOLOGY
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.summaryOfMammalianToxicology)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.summaryOfMammalianToxicology || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="displayMap['dermal'] && item.dermal">
                  <h6>
                    DERMAL
                    <button class="copy-btn" (click)="copyToClipboard(item.dermal)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dermal || "-" }}
                  </p>
                </div>
                <div class="product-info" *ngIf="displayMap['chronic'] && item.chronic">
                  <h6>
                    chronic
                    <button class="copy-btn" (click)="copyToClipboard(item.chronic)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.chronic || "-" }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['mammalianNonHumanAnimalsTox'] &&
                    item.mammalianNonHumanAnimalsTox
                  ">
                  <h6>
                    MAMMALIAN - NON-HUMAN ANIMALS TOX
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.mammalianNonHumanAnimalsTox)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.mammalianNonHumanAnimalsTox }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['birdsAcuteLd50MgKg'] && item.birdsAcuteLd50MgKg
                  ">
                  <h6>
                    BIRDS - ACUTE LD50 (mg/kg)
                    <button class="copy-btn" (click)="copyToClipboard(item.birdsAcuteLd50MgKg)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.birdsAcuteLd50MgKg || "-" }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['birdsShortTermDietaryLc50Ld50'] &&
                    item.birdsShortTermDietaryLc50Ld50
                  ">
                  <h6>
                    BIRDS - SHORT TERM DIETARY (LC50/LD50)
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.birdsShortTermDietaryLc50Ld50)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.birdsShortTermDietaryLc50Ld50 || "-" }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['fishAcute96HourLc50MgL'] &&
                    item.fishAcute96HourLc50MgL
                  ">
                  <h6>
                    FISH - ACUTE 96 HOUR LC50 (mg/l)
                    <button class="copy-btn" (click)="copyToClipboard(item.fishAcute96HourLc50MgL)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.fishAcute96HourLc50MgL || "-" }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['algaeAcute72HourEc50GrowthMgL'] &&
                    item.algaeAcute72HourEc50GrowthMgL
                  ">
                  <h6>
                    ALGAE - ACUTE 72 HOUR EC50, GROWTH (mg/l)
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.algaeAcute72HourEc50GrowthMgL)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.algaeAcute72HourEc50GrowthMgL || "-" }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['honeybeesToxicity'] && item.honeybeesToxicity
                  ">
                  <h6>
                    HONEYBEES- Toxicity
                    <button class="copy-btn" (click)="copyToClipboard(item.honeybeesToxicity)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.honeybeesToxicity || "-" }}
                  </p>
                </div>
                <div class="product-info" *ngIf="
                    displayMap['earthwormsAcute14DayLc50MgKg'] &&
                    item.earthwormsAcute14DayLc50MgKg
                  ">
                  <h6>
                    EARTHWORMS - ACUTE 14 DAY LC50 (MG/KG)
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.earthwormsAcute14DayLc50MgKg)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.earthwormsAcute14DayLc50MgKg || "-" }}
                  </p>
                </div>
              </div>
            </div>
            <button class="view-more"></button>
          </div>

          <div *ngIf="
              item.summaryOfMammalianHumanTox ||
              item.mammalsAcuteOralLd50MgKg ||
              item.mammalsDermalLd50MgKgBodyWeight ||
              item.mammalsInhalationLc50MgL ||
              item.mammalsShortTermDietaryNoelMgKg ||
              item.mammalsShortTermDietaryNoelPpmDiet ||
              item.adiAcceptableDailyIntakeMgKgBwPerDay ||
              item.arfdAcuteReferenceDoseMgKgBwPerDay ||
              item.aoelAcceptableOperatorExposureLevelSystemicMgKgBwPerDay ||
              item.exposureRoutesPublic ||
              item.exposureRoutesOccupational
            ">
            <div class="section-wrapper" id="mammalian-human-tox">
              <hr class="section-divider" />
              <h2 class="section-title">MAMMALIAN - HUMAN TOX</h2>
              <div class="product-detail" style="margin-top: 20px">
                <div class="grid grid-cols-2 gap-4">
                  <div class="product-info" *ngIf="
                      displayMap['summaryOfMammalianHumanTox'] &&
                      item.summaryOfMammalianHumanTox
                    ">
                    <h6>
                      SUMMARY of MAMMALIAN - HUMAN TOX
                      <button class="copy-btn" (click)="
                          copyToClipboard(item.summaryOfMammalianHumanTox)
                        " pTooltip="Copy to clipboard" tooltipPosition="top">
                        <i class="pi pi-copy"></i>
                      </button>
                    </h6>
                    <p>
                      {{ item.summaryOfMammalianHumanTox }}
                    </p>
                  </div>
                  <div class="product-info" *ngIf="
                      displayMap['mammalsAcuteOralLd50MgKg'] &&
                      item.mammalsAcuteOralLd50MgKg
                    ">
                    <h6>
                      MAMMALS - ACUTE ORAL LD50 (mg/kg)
                      <button class="copy-btn" (click)="copyToClipboard(item.mammalsAcuteOralLd50MgKg)"
                        pTooltip="Copy to clipboard" tooltipPosition="top">
                        <i class="pi pi-copy"></i>
                      </button>
                    </h6>

                    <p>
                      {{ item.mammalsAcuteOralLd50MgKg }}
                    </p>
                  </div>
                  <div class="product-info" *ngIf="
                      displayMap['mammalsDermalLd50MgKgBodyWeight'] &&
                      item.mammalsDermalLd50MgKgBodyWeight
                    ">
                    <h6>
                      MAMMALS - DERMAL LD50 (mg/kg BODY WEIGHT)
                      <button class="copy-btn" (click)="
                          copyToClipboard(item.mammalsDermalLd50MgKgBodyWeight)
                        " pTooltip="Copy to clipboard" tooltipPosition="top">
                        <i class="pi pi-copy"></i>
                      </button>
                    </h6>
                    <p>
                      {{ item.mammalsDermalLd50MgKgBodyWeight }}
                    </p>
                  </div>
                  <div class="product-info" *ngIf="
                      displayMap['mammalsInhalationLc50MgL'] &&
                      item.mammalsInhalationLc50MgL
                    ">
                    <h6>
                      MAMMALS - INHALATION LC50 (mg/l)
                      <button class="copy-btn" (click)="copyToClipboard(item.mammalsInhalationLc50MgL)"
                        pTooltip="Copy to clipboard" tooltipPosition="top">
                        <i class="pi pi-copy"></i>
                      </button>
                    </h6>
                    <p>
                      {{ item.mammalsInhalationLc50MgL }}
                    </p>
                  </div>
                  <div class="product-info" *ngIf="
                      displayMap['mammalsShortTermDietaryNoelMgKg'] &&
                      item.mammalsShortTermDietaryNoelMgKg
                    ">
                    <h6>
                      MAMMALS - SHORT TERM DIETARY NOEL (MG/KG)
                      <button class="copy-btn" (click)="
                          copyToClipboard(item.mammalsShortTermDietaryNoelMgKg)
                        " pTooltip="Copy to clipboard" tooltipPosition="top">
                        <i class="pi pi-copy"></i>
                      </button>
                    </h6>
                    <p>
                      {{ item.mammalsShortTermDietaryNoelMgKg }}
                    </p>
                  </div>
                  <div class="product-info" *ngIf="
                      displayMap['mammalsShortTermDietaryNoelPpmDiet'] &&
                      item.mammalsShortTermDietaryNoelPpmDiet
                    ">
                    <h6>
                      MAMMALS - SHORT TERM DIETARY NOEL (PPM DIET)
                      <button class="copy-btn" (click)="
                          copyToClipboard(
                            item.mammalsShortTermDietaryNoelPpmDiet
                          )
                        " pTooltip="Copy to clipboard" tooltipPosition="top">
                        <i class="pi pi-copy"></i>
                      </button>
                    </h6>
                    <p>
                      {{ item.mammalsShortTermDietaryNoelPpmDiet }}
                    </p>
                  </div>
                  <div class="product-info" *ngIf="
                      displayMap['adiAcceptableDailyIntakeMgKgBwPerDay'] &&
                      item.adiAcceptableDailyIntakeMgKgBwPerDay
                    ">
                    <h6>
                      ADI - ACCEPTABLE DAILY INTAKE (mg/kg BW PER DAY)
                      <button class="copy-btn" (click)="
                          copyToClipboard(
                            item.adiAcceptableDailyIntakeMgKgBwPerDay
                          )
                        " pTooltip="Copy to clipboard" tooltipPosition="top">
                        <i class="pi pi-copy"></i>
                      </button>
                    </h6>
                    <p>
                      {{ item.adiAcceptableDailyIntakeMgKgBwPerDay || "-" }}
                    </p>
                  </div>
                  <div class="product-info" *ngIf="
                      displayMap['arfdAcuteReferenceDoseMgKgBwPerDay'] &&
                      item.arfdAcuteReferenceDoseMgKgBwPerDay
                    ">
                    <h6>
                      ARFD - ACUTE REFERENCE DOSE (mg/kg BW PER DAY)
                      <button class="copy-btn" (click)="
                          copyToClipboard(
                            item.arfdAcuteReferenceDoseMgKgBwPerDay
                          )
                        " pTooltip="Copy to clipboard" tooltipPosition="top">
                        <i class="pi pi-copy"></i>
                      </button>
                    </h6>
                    <p>
                      {{ item.arfdAcuteReferenceDoseMgKgBwPerDay || "-" }}
                    </p>
                  </div>
                  <div class="product-info" *ngIf="
                      displayMap[
                        'aoelAcceptableOperatorExposureLevelSystemicMgKgBwPerDay'
                      ] &&
                      item.aoelAcceptableOperatorExposureLevelSystemicMgKgBwPerDay
                    ">
                    <h6>
                      AOEL - ACCEPTABLE OPERATOR EXPOSURE LEVEL - SYSTEMIC
                      (mg/kg BW PER DAY)
                      <button class="copy-btn" (click)="
                          copyToClipboard(
                            item.aoelAcceptableOperatorExposureLevelSystemicMgKgBwPerDay
                          )
                        " pTooltip="Copy to clipboard" tooltipPosition="top">
                        <i class="pi pi-copy"></i>
                      </button>
                    </h6>
                    <p>
                      {{
                      item.aoelAcceptableOperatorExposureLevelSystemicMgKgBwPerDay ||
                      "-"
                      }}
                    </p>
                  </div>
                  <div class="product-info" *ngIf="
                      displayMap['exposureRoutesPublic'] &&
                      item.exposureRoutesPublic
                    ">
                    <h6>
                      EXPOSURE ROUTES- PUBLIC
                      <button class="copy-btn" (click)="copyToClipboard(item.exposureRoutesPublic)"
                        pTooltip="Copy to clipboard" tooltipPosition="top">
                        <i class="pi pi-copy"></i>
                      </button>
                    </h6>

                    <p>
                      {{ item.exposureRoutesPublic || "-" }}
                    </p>
                  </div>
                  <div class="product-info" *ngIf="
                      displayMap['exposureRoutesOccupational'] &&
                      item.exposureRoutesOccupational
                    ">
                    <h6>
                      EXPOSURE ROUTES- OCCUPATIONAL
                      <button class="copy-btn" (click)="
                          copyToClipboard(item.exposureRoutesOccupational)
                        " pTooltip="Copy to clipboard" tooltipPosition="top">
                        <i class="pi pi-copy"></i>
                      </button>
                    </h6>

                    <p>
                      {{ item.exposureRoutesOccupational || "-" }}
                    </p>
                  </div>
                </div>
              </div>

              <button class="view-more"></button>
            </div>
          </div>

          <div class="section-wrapper" id="supplementary-protection-certificate"
            *ngIf="item.SUPPLEMENTARY_PROTECTION_CERTIFICATE">
            <hr class="section-divider" />
            <h2 class="section-title">
              SUPPLEMENTARY PROTECTION CERTIFICATE (SPC)
            </h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-1 gap-4">
                <div class="product-info" *ngIf="
                    displayMap['SUPPLEMENTARY_PROTECTION_CERTIFICATE'] &&
                    item.SUPPLEMENTARY_PROTECTION_CERTIFICATE
                  ">
                  <h6>
                    SPC (SOLO PRODUCT)
                    <button class="copy-btn" (click)="
                        copyToClipboard(
                          item.SUPPLEMENTARY_PROTECTION_CERTIFICATE
                        )
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.SUPPLEMENTARY_PROTECTION_CERTIFICATE }}
                  </p>
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>

          <div class="section-wrapper" id="data-protection-solo-product" *ngIf="item.dataProtection">
            <hr class="section-divider" />
            <h2 class="section-title">DATA PROTECTION (Solo Product)</h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-1 gap-4">
                <div class="product-info" *ngIf="displayMap['dataProtection'] && item.dataProtection">
                  <h6>
                    SUMMARY
                    <button class="copy-btn" (click)="copyToClipboard(item.dataProtection)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dataProtection }}
                  </p>
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>

          <div class="section-wrapper" id="key-starting-material" *ngIf="item.keyStartingMaterialUsedInGivenProcessKsm">
            <hr class="section-divider" />
            <h2 class="section-title">KEY STARTING MATERIAL (KSM)</h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-1 gap-4">
                <div class="product-info" *ngIf="
                    displayMap['keyStartingMaterialUsedInGivenProcessKsm'] &&
                    item.keyStartingMaterialUsedInGivenProcessKsm
                  ">
                  <h6>
                    SUMMARY KEY STARTING MATERIAL (KSM)
                    <button class="copy-btn" (click)="
                        copyToClipboard(
                          item.keyStartingMaterialUsedInGivenProcessKsm
                        )
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.keyStartingMaterialUsedInGivenProcessKsm }}
                  </p>
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>

          <div class="section-wrapper" id="environmental-fate"
            *ngIf="item.summaryOfEnvironmentalFate || item.soilDegradation">
            <hr class="section-divider" />
            <h2 class="section-title">ENVIRONMENTAL FATE</h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div class="product-info single-column" *ngIf="
                    displayMap['summaryOfEnvironmentalFate'] &&
                    item.summaryOfEnvironmentalFate
                  ">
                  <h6>
                    SUMMARY of ENVIRONMENTAL FATE
                    <button class="copy-btn" (click)="copyToClipboard(item.summaryOfEnvironmentalFate)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.summaryOfEnvironmentalFate }}
                  </p>
                </div>
                <div class="product-info" *ngIf="displayMap['soilDegradation'] && item.soilDegradation">
                  <h6>
                    SOIL DEGRADATION
                    <button class="copy-btn" (click)="copyToClipboard(item.soilDegradation)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.soilDegradation || "-" }}
                  </p>
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>

          <div *ngIf="
              item.dissipationRateRl50OnPlantMatrixRateGHa ||
              item.dissipationRateRl50OnAndInPlantMatrix ||
              item.waterSedimentDt50Days ||
              item.waterPhaseOnlyDt50Days
            " class="section-wrapper" id="DISSIPATION-STUDIES">
            <hr class="section-divider" />
            <h2 class="section-title">DISSIPATION STUDIES</h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div class="product-info" *ngIf="
                    displayMap['dissipationRateRl50OnPlantMatrixRateGHa'] &&
                    item.dissipationRateRl50OnPlantMatrixRateGHa
                  ">
                  <h6>
                    DISSIPATION RATE RL50 ON PLANT MATRIX (RATE G/HA)
                    <button class="copy-btn" (click)="
                        copyToClipboard(
                          item.dissipationRateRl50OnPlantMatrixRateGHa
                        )
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dissipationRateRl50OnPlantMatrixRateGHa || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="
                    displayMap['dissipationRateRl50OnAndInPlantMatrix'] &&
                    item.dissipationRateRl50OnAndInPlantMatrix
                  ">
                  <h6>
                    DISSIPATION RATE RL50 ON AND IN PLANT MATRIX
                    <button class="copy-btn" (click)="
                        copyToClipboard(
                          item.dissipationRateRl50OnAndInPlantMatrix
                        )
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dissipationRateRl50OnAndInPlantMatrix || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="
                    displayMap['waterSedimentDt50Days'] &&
                    item.waterSedimentDt50Days
                  ">
                  <h6>
                    WATER-SEDIMENT DT50 (DAYS)
                    <button class="copy-btn" (click)="copyToClipboard(item.waterSedimentDt50Days)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.waterSedimentDt50Days || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="
                    displayMap['waterPhaseOnlyDt50Days'] &&
                    item.waterPhaseOnlyDt50Days
                  ">
                  <h6>
                    WATER PHASE ONLY DT50 (DAYS)
                    <button class="copy-btn" (click)="copyToClipboard(item.waterPhaseOnlyDt50Days)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.waterPhaseOnlyDt50Days || "-" }}
                  </p>
                </div>
              </div>
            </div>
            <button class="view-more"></button>
          </div>
          <div *ngIf="
              item.agueousPhotolysisDt50DaysAtPh7 ||
              item.agueousHydrolysisDt50DaysAt20CAndPh7
            " class="section-wrapper" id="PHOTOLYTIC-DECOMPOSITION">
            <hr class="section-divider" />
            <h2 class="section-title">PHOTOLYTIC DECOMPOSITION</h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div class="product-info" *ngIf="
                    item.agueousPhotolysisDt50DaysAtPh7 ||
                    item.agueousHydrolysisDt50DaysAt20CAndPh7
                  ">
                  <h6>
                    AQUEOUS PHOTOLYSIS DT50 (DAYS) AT pH 7

                    <button class="copy-btn" (click)="
                        copyToClipboard(item.agueousPhotolysisDt50DaysAtPh7)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p *ngIf="
                      displayMap['agueousPhotolysisDt50DaysAtPh7'] &&
                      item.agueousPhotolysisDt50DaysAtPh7
                    ">
                    {{ item.agueousPhotolysisDt50DaysAtPh7 || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="
                    displayMap['agueousHydrolysisDt50DaysAt20CAndPh7'] &&
                    item.agueousHydrolysisDt50DaysAt20CAndPh7
                  ">
                  <h6>
                    AQUEOUS HYDROLYSIS DT50 (DAYS) AT 20 (°C) AND pH 7
                    <button class="copy-btn" (click)="
                        copyToClipboard(
                          item.agueousHydrolysisDt50DaysAt20CAndPh7
                        )
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.agueousHydrolysisDt50DaysAt20CAndPh7 || "-" }}
                  </p>
                </div>
              </div>
            </div>
            <button class="view-more"></button>
          </div>
          <div *ngIf="
              item.soilAdsorptionCoefficientKd ||
              item.soilAdsorptionCoefficientKoc ||
              item.freundlichAdsorptionCoefficientKf ||
              item.organicCarbonNormalizedFreundlichAdsorptionCoefficientKfoc ||
              item.freundlichExponent1N ||
              item.PH
            " class="section-wrapper" id="SOIL-ADSORPTION-AND-MOBILITY-STUDIES">
            <hr class="section-divider" />
            <h2 class="section-title">SOIL ADSORPTION AND MOBILITY STUDIES</h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div class="product-info" *ngIf="
                    displayMap['soilAdsorptionCoefficientKd'] &&
                    item.soilAdsorptionCoefficientKd
                  ">
                  <h6>
                    SOIL ADSORPTION COEFFICIENT (KD)
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.soilAdsorptionCoefficientKd)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.soilAdsorptionCoefficientKd || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="
                    displayMap['soilAdsorptionCoefficientKoc'] &&
                    item.soilAdsorptionCoefficientKoc
                  ">
                  <h6>
                    SOIL ADSORPTION COEFFICIENT (KOC)
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.soilAdsorptionCoefficientKoc)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.soilAdsorptionCoefficientKoc || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="
                    displayMap['freundlichAdsorptionCoefficientKf'] &&
                    item.freundlichAdsorptionCoefficientKf
                  ">
                  <h6>
                    FREUNDLICH ADSORPTION COEFFICIENT (Kf)
                    <button class="copy-btn" (click)="
                        copyToClipboard(item.freundlichAdsorptionCoefficientKf)
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.freundlichAdsorptionCoefficientKf || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="
                    displayMap[
                      'organicCarbonNormalizedFreundlichAdsorptionCoefficientKfoc'
                    ] &&
                    item.organicCarbonNormalizedFreundlichAdsorptionCoefficientKfoc
                  ">
                  <h6>
                    ORGANIC CARBON NORMALIZED FREUNDLICH ADSORPTION COEFFICIENT
                    (Kfoc)
                    <button class="copy-btn" (click)="
                        copyToClipboard(
                          item.organicCarbonNormalizedFreundlichAdsorptionCoefficientKfoc
                        )
                      " pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{
                    item.organicCarbonNormalizedFreundlichAdsorptionCoefficientKfoc ||
                    "-"
                    }}
                  </p>
                </div>

                <div class="product-info" *ngIf="isColumnVisible(item, 'freundlichExponent1N')">
                  <h6>
                    FREUNDLICH EXPONENT (1/n)
                    <button class="copy-btn" (click)="copyToClipboard(item.freundlichExponent1N)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.freundlichExponent1N || "-" }}
                  </p>
                </div>

                <div class="product-info" *ngIf="displayMap['PH'] && item.PH">
                  <h6>
                    pH SENSITIVITY
                    <button class="copy-btn" (click)="copyToClipboard(item.PH)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.PH || "-" }}
                  </p>
                </div>
              </div>
            </div>
            <button class="view-more"></button>
          </div>

          <div *ngIf="item.summaryMetabolites || item.metabolites" class="section-wrapper" id="metabolites">
            <hr class="section-divider" />
            <h2 class="section-title">Metabolites</h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div *ngIf="isColumnVisible(item, 'summaryMetabolites')" class="product-info">
                  <h6>
                    SUMMARY METABOLITES
                    <button class="copy-btn" (click)="copyToClipboard(item.summaryMetabolites)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.summaryMetabolites }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'metabolites')" class="product-info">
                  <h6>
                    METABOLITES
                    <button class="copy-btn" (click)="copyToClipboard(item.metabolites)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.metabolites || "-" }}
                  </p>
                </div>
              </div>
            </div>
            <button class="view-more"></button>
          </div>

          <div *ngIf="isColumnVisible(item, 'SAFETY_DATA')" class="section-wrapper" id="safety-data">
            <hr class="section-divider" />
            <h2 class="section-title">
              SAFETY DATA
              <button class="copy-btn" (click)="copyToClipboard(item.SAFETY_DATA)" pTooltip="Copy to clipboard"
                tooltipPosition="top">
                <i class="pi pi-copy"></i>
              </button>
            </h2>
            <p>
              {{ item.SAFETY_DATA }}
            </p>
            <button class="view-more"></button>
          </div>

          <div *ngIf="
              item.summarySalesDataSalesYearM ||
              item.salesData ||
              item.competitors
            " class="section-wrapper" id="sales-data">
            <hr class="section-divider" />
            <h2 class="section-title">SALES DATA (Sales / Year ($m.))</h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div *ngIf="isColumnVisible(item, 'summarySalesDataSalesYearM')" class="product-info">
                  <h6>
                    SUMMARY SALES DATA (Sales / Year ($m.))
                    <button class="copy-btn" (click)="copyToClipboard(item.summarySalesDataSalesYearM)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.summarySalesDataSalesYearM }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'salesData')" class="product-detail" style="margin-top: 20px">
                  <h6>
                    SALES DATA
                    <button class="copy-btn" (click)="copyToClipboard(item.salesData)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.salesData }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'competitors')" class="product-detail" style="margin-top: 20px">
                  <h6>
                    competitors
                    <button class="copy-btn" (click)="copyToClipboard(item.competitors)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.competitors }}
                  </p>
                </div>
              </div>
            </div>
            <button class="view-more"></button>
          </div>

          <div *ngIf="item.PRICING" class="section-wrapper" id="pricing">
            <hr class="section-divider" />
            <h2 class="section-title">PRICING</h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div *ngIf="isColumnVisible(item, 'PRICING')" class="product-info">
                  <h6>
                    SUMMARY PRICING
                    <button class="copy-btn" (click)="copyToClipboard(item.PRICING)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.PRICING }}
                  </p>
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>

          <div *ngIf="item.keyTechnologies" class="section-wrapper" id="product-technologies">
            <hr class="section-divider" />
            <h2 class="section-title">PRODUCT TECHNOLOGIES</h2>
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div *ngIf="isColumnVisible(item, 'keyTechnologies')" class="product-info">
                  <h6>
                    SUMMARY TECHNOLOGY
                    <button class="copy-btn" (click)="copyToClipboard(item.keyTechnologies)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.keyTechnologies }}
                  </p>
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>

          <div *ngIf="item.informationSources || item.remarks" class="section-wrapper" id="literature">
            <hr class="section-divider" />
            <h2 class="section-title">LITERATURE</h2>
            <div class="product-details" style="margin-top: 20px">
              <div class="grid grid-cols-1 gap-4">
                <div *ngIf="isColumnVisible(item, 'informationSources')" class="product-info">
                  <h6>
                    INFORMATION SOURCES
                    <button class="copy-btn" (click)="copyToClipboard(item.informationSources)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.informationSources }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'remarks')" class="product-info">
                  <h6>
                    REMARKS
                    <button class="copy-btn" (click)="copyToClipboard(item.remarks)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.remarks }}
                  </p>
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>
          <div *ngIf="
              item.usdmfHolder || item.EP_DMF_HOLDER || item.otherDmfHolder
            " class="section-wrapper" id="holder">
            <hr class="section-divider" />
            <h2 class="section-title">Holder</h2>
            <div class="product-details" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div *ngIf="isColumnVisible(item, 'usdmfHolder')" class="product-info">
                  <h6>
                    USDMF HOLDER
                    <button class="copy-btn" (click)="copyToClipboard(item.usdmfHolder)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.usdmfHolder }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'EP_DMF_HOLDER')" class="product-info">
                  <h6>
                    EP DMF HOLDER
                    <button class="copy-btn" (click)="copyToClipboard(item.EP_DMF_HOLDER)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.EP_DMF_HOLDER }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'otherDmfHolder')" class="product-info">
                  <h6>
                    otherDmfHolder
                    <button class="copy-btn" (click)="copyToClipboard(item.otherDmfHolder)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.otherDmfHolder }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="
              item.link1 ||
              item.link2 ||
              item.link3 ||
              item.link4 ||
              item.link5 ||
              item.link6
            " class="section-wrapper" id="link">
            <hr class="section-divider" />
            <h2 class="section-title">LINK</h2>
            <div class="product-details" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div *ngIf="isColumnVisible(item, 'link1')" class="product-info">
                  <h6>
                    LINK-1
                    <button class="copy-btn" (click)="copyToClipboard(item.link1)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.link1 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.link1 || '-')"></p> -->
                </div>
                <div *ngIf="isColumnVisible(item, 'link2')" class="product-info">
                  <h6>
                    LINK-2
                    <button class="copy-btn" (click)="copyToClipboard(item.link2)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.link2 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.link2 || '-')"></p> -->
                </div>
                <div *ngIf="isColumnVisible(item, 'link3')" class="product-info">
                  <h6>
                    LINK-3
                    <button class="copy-btn" (click)="copyToClipboard(item.link3)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.link3 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.link3 || '-')"></p> -->
                </div>
                <div *ngIf="isColumnVisible(item, 'link4')" class="product-info">
                  <h6>
                    LINK-4
                    <button class="copy-btn" (click)="copyToClipboard(item.link4)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.link4 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.link4 || '-')"></p> -->
                </div>
                <div *ngIf="isColumnVisible(item, 'link5')" class="product-info">
                  <h6>
                    LINK-5
                    <button class="copy-btn" (click)="copyToClipboard(item.link5)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.link5 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.link5 || '-')"></p> -->
                </div>
                <div *ngIf="isColumnVisible(item, 'link6')" class="product-info">
                  <h6>
                    LINK-6
                    <button class="copy-btn" (click)="copyToClipboard(item.link6)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.link6 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.link6 || '-')"></p> -->
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>

          <div *ngIf="
              item.dummy1 ||
              item.dummy2 ||
              item.dummy3 ||
              item.dummy4 ||
              item.dummy5 ||
              item.dummy6 ||
              item.dummy7 ||
              item.dummy8 ||
              item.dummy9 ||
              item.dummy10 ||
              item.dummy11 ||
              item.dummy12 ||
              item.dummy13 ||
              item.dummy14
            " class="section-wrapper" id="dummy">
            <hr class="section-divider" />
            <h2 class="section-title">DUMMY</h2>
            <div class="product-details" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div *ngIf="isColumnVisible(item, 'dummy1')" class="product-info">
                  <h6>
                    DUMMY 1
                    <button class="copy-btn" (click)="copyToClipboard(item.dummy1)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy1 }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'dummy2')" class="product-info">
                  <h6>
                    DUMMY 2
                    <button class="copy-btn" (click)="copyToClipboard(item.dummy2)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy2 }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'dummy3')" class="product-info">
                  <h6>
                    DUMMY 3
                    <button class="copy-btn" (click)="copyToClipboard(item.dummy3)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy3 }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'dummy4')" class="product-info">
                  <h6>
                    DUMMY 4
                    <button class="copy-btn" (click)="copyToClipboard(item.dummy4)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy4 }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'dummy5')" class="product-info">
                  <h6>
                    DUMMY 5
                    <button class="copy-btn" (click)="copyToClipboard(item.dummy5)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy5 }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'otherDmfHolder')" class="product-info">
                  <h6>
                    DUMMY 6
                    <button class="copy-btn" (click)="copyToClipboard(item.dummy6)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy6 }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'dummy7')" class="product-info">
                  <h6>
                    DUMMY 7
                    <button class="copy-btn" (click)="copyToClipboard(item.dummy7)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy7 }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'dummy8')" class="product-info">
                  <h6>
                    DUMMY 8
                    <button class="copy-btn" (click)="copyToClipboard(item.dummy1)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy8 }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'dummy9')" class="product-info">
                  <h6>
                    DUMMY 9
                    <button class="copy-btn" (click)="copyToClipboard(item.dummy9)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy9 }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'dummy10')" class="product-info">
                  <h6>
                    DUMMY 10
                    <button class="copy-btn" (click)="copyToClipboard(item.dummy10)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy10 }}
                  </p>
                  >
                </div>
                <div *ngIf="isColumnVisible(item, 'dummy11')" class="product-info">
                  <h6>
                    DUMMY 11
                    <button class="copy-btn" (click)="copyToClipboard(item.dummy11)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy11 }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'dummy12')" class="product-info">
                  <h6>
                    DUMMY 12
                    <button class="copy-btn" (click)="copyToClipboard(item.dummy12)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy12 }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'dummy13')" class="product-info">
                  <h6>
                    DUMMY 13
                    <button class="copy-btn" (click)="copyToClipboard(item.dummy13)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy13 }}
                  </p>
                </div>
                <div *ngIf="isColumnVisible(item, 'dummy14')" class="product-info">
                  <h6>
                    DUMMY 14
                    <button class="copy-btn" (click)="copyToClipboard(item.dummy14)" pTooltip="Copy to clipboard"
                      tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy14 }}
                  </p>
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>
        </div>
        <button class="back_to_top my-5" (click)="scrollToTop()">
          <img class="back_to_top_img" src="../../../assets/icons/output-onlinepngtools (5).png" />
        </button>
      </section>
    </div>
    <!-- Sidebar -->
    <aside class="sidebar">
      <h3 class="sidebar-title">
        Products Highlight
        <button class="sidebar-toggle" (click)="toggleSidebar()">
          <span *ngIf="!isSidebarOpen">☰</span>
          <span *ngIf="isSidebarOpen">×</span>
        </button>
      </h3>

      <ul [class.active]="isSidebarOpen">
        <ng-container *ngFor="let option of filteredSidebarOptions; let i = index">
          <li [ngClass]="{ selected: highlightedIndex === i }" (click)="scrollToSection(option, i)">
            {{ option }}
          </li>

          <!-- Subheadings for Invent Info -->
          <ng-container *ngIf="option === 'Invent Info'">
            <li class="sidebar-subheading" *ngIf="hasColumnValue('inventInfo')"
              (click)="scrollToSubSection('global-patent'); $event.stopPropagation();">
              1. Global Patent(US, EP, JP, AU, IN)
            </li>
            <li class="sidebar-subheading" *ngIf="hasColumnValue('dummy7')"
              (click)="scrollToSubSection('brazil-patent'); $event.stopPropagation();">
              2. Brazil Patent
            </li>
          </ng-container>
        </ng-container>
      </ul>
    </aside>
  </div>
</div>